import { render, staticRenderFns } from "./adminadd.vue?vue&type=template&id=d61f9366&scoped=true&"
import script from "./adminadd.vue?vue&type=script&lang=js&"
export * from "./adminadd.vue?vue&type=script&lang=js&"
import style0 from "./adminadd.vue?vue&type=style&index=0&id=d61f9366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61f9366",
  null
  
)

export default component.exports